module.exports = function() { return __webpack_public_path__ + "browse.2Af0BqLMkFQtrZa8ldNQ.svg";};